$(document).on('click', '.close-flash-item', function() {
  $(this).closest('.flash-item').remove();
});
